// extracted by mini-css-extract-plugin
export default {"container":"InvoiceBankInfo_container__x4e2k"};